module.exports = __webpack_public_path__ + "static/media/arrow-alt-up.9dfedcee.svg";